<template>
  <div class="vx-row">
      <vx-card title="TENANT LIST" v-can:any="['create-user', 'view-user']">
        <template slot="actions">
          <div class="flex float-right">
            <div class="con-btns-user flex items-center justify-between">
              <div class="flex mb-4">
                <vs-button  v-can="'create-user'" @click="onClickCreateTenant" class="mr-4" color="primary" type="filled">Create Tenant</vs-button>
                <vs-button v-can="'create-user'" @click="onClickRefresh" class="mr-0" color="success" type="border"
                           icon-pack="feather" icon="icon-rotate-cw"></vs-button>
              </div>
            </div>
          </div>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                    v-model="filters['search']"
                    class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
          <vs-table v-can="'view-user'" :max-items="(meta.per_page) ? meta.per_page : 10" id="tenants-table"
                    :data="tenants_list"  @sort="handleSort"  :sst="true" stripe
                    class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th width="10%">CLIENT BUSINESS NAME</vs-th>
              <vs-th width="10%">ACCOUNT OWNER</vs-th>
              <vs-th width="15%">DOMAIN</vs-th>
              <vs-th width="10%">EMAIL</vs-th>
              <vs-th width="10%">STATUS</vs-th>
              <vs-th width="10%">CREATED BY</vs-th>
              <vs-th width="10%">SETUP DATE</vs-th>
<!--              <vs-th width="10%">GoCardless ID</vs-th>-->
              <vs-th width="15%" v-can="'edit-user'">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr class="cursor-pointer" @click.native="onClickTenantView(data[indextr].id)"  :key="indextr" v-for="(tr, indextr) in data">


                <vs-td :data="data[indextr].name">
                  <span class="text-primary"> {{ data[indextr].name }} <br> {{ data[indextr].account_number }}</span>
                </vs-td>

                <vs-td :data="data[indextr].first_name">
                  {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].domain }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email }}
                </vs-td>

                <vs-td :data="data[indextr].status">
                  {{ data[indextr].status }}
                </vs-td>

                <vs-td :data="data[indextr].created_by">
                  {{ data[indextr].created_by}}
                </vs-td>

                <vs-td :data="data[indextr].created_at">
                  {{ __dateTimeFormatterToDate(data[indextr].created_at) }}
                </vs-td>

<!--                <vs-td :data="data[indextr].gocardless_id">-->

<!--                  <span v-if="data[indextr].gocardless_id.length > 0">-->
<!--                    {{ data[indextr].gocardless_id || 'N/A' }}-->
<!--                  </span>-->

<!--                  <vx-tooltip v-else class="mr-2" text="Create GoCardless customer" position="left">-->
<!--                    <vs-button @click.stop="onClickSyncCustomer(data[indextr])"-->
<!--                               size="small" color="danger" type="border" icon-pack="feather" icon="icon-refresh-cw">-->
<!--                    </vs-button>-->
<!--                  </vx-tooltip>-->

<!--                </vs-td>-->

                <vs-td v-can="'edit-user'">
                  <div class="vx-row">
                    <vx-tooltip class="mr-2" text="Deploy Tenant" position="top" v-if="['Not Deployed'].includes(data[indextr].status)">
                      <vs-button @click.stop="onClickDeployTenant(data[indextr].id)"
                                 size="small" color="success" type="border" icon-pack="feather" icon="icon-fast-forward"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" text="View/Update" position="top" v-if="['Pending Verification', 'Active'].includes(data[indextr].status)">
                      <vs-button @click.stop="onClickTenantView(data[indextr].id)"
                                 size="small" color="warning" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" text="Delete Tenant" position="top" v-if="['Pending Verification', 'Active', 'Not Deployed'].includes(data[indextr].status)">
                      <vs-button @click.stop="onClickDeleteTenantConfirmation(data[indextr])"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" :text="data[indextr].domain" position="top" v-if="['Pending Verification', 'Active'].includes(data[indextr].status)">
                      <vs-button @click.stop="onClickNavigateToTenant(data[indextr].domain)"
                                 size="small" color="success" type="border" icon-pack="feather" icon="icon-navigation">
                        Navigate
                      </vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>


          </vs-table>
          <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

        </div>
      </vx-card>
    <create-tenant-pop-up ref="createTenantPopUp"/>
    <update-tenant-pop-up ref="updateTenantPopUp"/>
    <vs-prompt
      :title="`Delete tenant '${delete_obj.suggest_name}' ?`"
      color="danger"
      :is-valid="validNameForDelete"
      acceptText="Delete tenant"
      @cancel="delete_obj.name=''"
      @accept="onClickRemoveTenant"
      :active.sync="activeDeletePrompt">
      <div class="con-exemple-prompt">
        <span>To confirm deletion, enter the name of the tenant in the text input field</span>
      <vs-input placeholder="name" vs-placeholder="name" v-model="delete_obj.name" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import CreateTenantPopUp from "@/components/popups/tenants/CreateTenantPopUp";
import UpdateTenantPopUp from "@/components/popups/tenants/UpdateTenantPopUp";
const TenantRepository = RepositoryFactory.get('tenant')
const CustomerRepository = RepositoryFactory.get('customer')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  name: 'TenantList',
  data () {
    return {
      tenants_list: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      delete_obj: {
        name: '',
        id: '',
        suggest_name: ''
      },
      activeDeletePrompt: false,
    }
  },
  components: {
    CreateTenantPopUp,
    UpdateTenantPopUp,
  },
  methods: {
    async refreshData () {
      await this.fetchTenants()
    },
    async onClickTenantUpdate (id) {
      await this.$refs.updateTenantPopUp.openPopup(id)
    },
    async onClickTenantView (id) {
      await this.$router.push({path: `/pages/tenants/${id}`})
    },
    onClickNavigateToTenant(domain) {
      window.open(`https://${domain}.m.souqbox.io/`, '_blank');
    },
    async onClickDeployTenant(tenant_id) {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        await TenantRepository.deployTenant(tenant_id)
        await this.fetchTenants()
      } catch (error) {
        
      } finally {
        await this.$vs.loading.close('#tenants-table > .con-vs-loading')
      }
    },
    async onClickSyncCustomer(item) {
      this.$vs.loading();
      try {
        const payload = {
          tenant_id: item.id,
          params: {
            address_line1: "10 Richard Street",
            address_line2: "Marlow Road",
            address_line3: "",
            city: "Reading",
            company_name: "Sainsbury",
            country_code: "GB",
            email: item.email,
            postal_code: "RG16 7QW"
          }
        }
        await CustomerRepository.createCustomer(payload)
        this.showSuccessMessage('New go cardless customer created')
        await this.refreshData()
      }catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async fetchTenants() {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        const {data} = await TenantRepository.get(this.page, this.filterQuery, 10, this.sort)
        this.tenants_list =  data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
    onClickDeleteTenantConfirmation(data) {
      this.delete_obj.id = data.id
      this.delete_obj.name = '',
      this.delete_obj.suggest_name = data.name
      this.activeDeletePrompt = true
    },
    async onClickRemoveTenant() {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        await TenantRepository.deleteTenant(this.delete_obj.id, { name: this.delete_obj.name })
        await this.fetchTenants()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
    domainSplitter(domain) {
      return domain.split('.')[0]
    },
    async onClickCreateTenant () {
      await this.$refs.createTenantPopUp.openPopup()
    },
    async onClickRefresh() {
      await this.fetchTenants()
    },
    filterQueryUpdate (){
      this.fetchTenants()
    },
    handleChangePage(page) {
      this.page=page;
      this.fetchTenants()
    },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchTenants()
      }
    }
  },
  watch : {
    page(){
      this.fetchTenants()
    }
  },
  computed: {
    validNameForDelete() {
      return this.delete_obj.name === this.delete_obj.suggest_name
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped>

</style>
